var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgJar1(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 367 535",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M296.3 133.65H68.74l-44.43 88.1a42.165 42.165 0 00-5.14 20.16v197.32c0 42.19 34.2 76.39 76.39 76.39h176.36c42.19 0 76.39-34.2 76.39-76.39V242.15c0-7.19-1.84-14.27-5.35-20.55l-46.66-87.95z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 32,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.39 7.89h-147c-39.682 0-71.85 32.169-71.85 71.85v25.47c0 39.682 32.168 71.85 71.85 71.85h147c39.682 0 71.85-32.168 71.85-71.85V79.74c0-39.681-32.168-71.85-71.85-71.85z",
    fill: "#FD934F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M265.48 2.61H93.86c-32.883 0-59.54 26.655-59.54 59.535 0 32.88 26.657 59.535 59.54 59.535h171.62c32.883 0 59.54-26.655 59.54-59.535 0-32.88-26.657-59.535-59.54-59.535z",
    fill: "#FED425"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M301.59 424.16H65.9c-25.808 0-46.73 20.922-46.73 46.73 0 25.808 20.922 46.73 46.73 46.73h235.69c25.808 0 46.73-20.922 46.73-46.73 0-25.808-20.922-46.73-46.73-46.73z",
    fill: "#EEF9FA",
    stroke: "#CDE2E4",
    strokeWidth: 27.47,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.32 52.63h-80.35c-7.097 0-12.85 5.753-12.85 12.85v1.44c0 7.097 5.753 12.85 12.85 12.85h80.35c7.097 0 12.85-5.753 12.85-12.85v-1.44c0-7.097-5.753-12.85-12.85-12.85z",
    fill: "#2A848E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M278.51 411.57H89.78c-16.105 0-29.16 13.055-29.16 29.16v15.82c0 16.104 13.056 29.16 29.16 29.16h188.73c16.105 0 29.16-13.056 29.16-29.16v-15.82c0-16.105-13.055-29.16-29.16-29.16z",
    fill: "#FED425",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60.62 417.88v25.1c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-23.93l-76.39-1.17h-.01z",
    fill: "#FED425"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M60.62 417.88v25.1c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-23.93l-76.39-1.17h-.01z",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M98.82 437.4c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M98.82 437.4c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M146.7 417.88v25.1c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-23.93l-76.39-1.17h-.01z",
    fill: "#FED425"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.7 417.88v25.1c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-23.93l-76.39-1.17h-.01z",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M184.9 437.4c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M184.9 437.4c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M231.28 417.88v25.1c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-23.93l-76.39-1.17h-.01z",
    fill: "#FED425"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M231.28 417.88v25.1c0 13.75 17.1 24.9 38.2 24.9s38.2-11.15 38.2-24.9v-23.93l-76.39-1.17h-.01z",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M269.47 437.4c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    fill: "#FED425"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M269.47 437.4c21.097 0 38.2-11.148 38.2-24.9 0-13.752-17.103-24.9-38.2-24.9s-38.2 11.148-38.2 24.9c0 13.752 17.103 24.9 38.2 24.9z",
    stroke: "#FD934F",
    strokeWidth: 12.8,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M292.71 266.55v-24.4c0-7.19-1.84-14.27-5.35-20.55l-9-16.97M292.71 395.48v-81.34",
    stroke: "#FBFDFE",
    strokeWidth: 21,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJar1);
export default ForwardRef;